/*
 * @Description:
 * @Author: muqingkun
 * @Date: 2023-07-21 14:01:01
 * @LastEditTime: 2024-02-28 20:18:50
 * @LastEditors: Please set LastEditors
 * @Reference:
 */
import { LOCAL_LANG } from '@/utils/const';
// 在导出@/plugins/i18n之前设置默认语言，否则默认CN
if (!localStorage.getItem('lang')) {
  localStorage.setItem('lang', LOCAL_LANG.value);
}
import App from './App.vue';
import router from './router';
import { setupStore } from '@/store';
import ElementPlus from 'element-plus';
import { getServerConfig } from './config';
import { createApp, Directive } from 'vue';
import { I18nPlugin, avLang, i18n, i18nGlobal } from '@/plugins/i18n';
import { MotionPlugin } from '@vueuse/motion';
import { useEcharts } from '@/plugins/echarts';
// import { createI18n } from 'vue-i18n';
import { injectResponsiveStorage } from '@/utils/responsive';
import { addDateRange, resetForm, clearFormValidate } from '@/utils/mixins';
import useBaseComponents from '@/components';
import getLodop from '@/plugins/lodop/lodopFuncs';
import ImagePreview from '@/components/ImagePreview';
// import ImagePreview from '@/components/BaseComponents/ImagePreview/instance';
// import Table from "@pureadmin/table";
// import PureDescriptions from "@pureadmin/descriptions";
// import './permission' // permission control
// 引入重置样式
import './style/reset.scss';
// 导入公共样式
import './style/index.scss';
// 一定要在main.ts中导入tailwind.css，防止vite每次hmr都会请求src/style/index.scss整体css文件导致热更新慢的问题
import './style/tailwind.css';
import 'element-plus/dist/index.css';
// 导入字体图标
import './assets/iconfont/iconfont.js';
import './assets/iconfont/iconfont.css';
import Avue from '@smallwei/avue';
const app = createApp(App);
useBaseComponents(app);
// 自定义指令
import * as directives from '@/directives';
Object.keys(directives).forEach(key => {
  app.directive(key, (directives as { [key: string]: Directive })[key]);
});

// 全局注册`@iconify/vue`图标库
import {
  IconifyIconOffline,
  IconifyIconOnline,
  FontIcon
} from './components/ReIcon';
app.component('IconifyIconOffline', IconifyIconOffline);
app.component('IconifyIconOnline', IconifyIconOnline);
app.component('FontIcon', FontIcon);

// 全局注册按钮级别权限组件
import 'virtual:svg-icons-register';
import SvgIcon from '@/components/SvgIcon/index.vue';
import elementIcons from '@/components/SvgIcon/svgicon.js';
app.use(elementIcons);
app.component('svg-icon', SvgIcon);

// 字典标签组件
import DictTag from '@/components/DictTag/index.vue';
app.component('DictTag', DictTag);
import { Auth } from '@/components/ReAuth';
app.component('Auth', Auth);

// 全局方法挂载
app.config.globalProperties.addDateRange = addDateRange;
app.config.globalProperties.resetForm = resetForm;
app.config.globalProperties.clearFormValidate = clearFormValidate;
app.config.globalProperties.$getLodop = getLodop;
app.config.globalProperties.$imgPreview = ImagePreview;
// use(FastCrud, { i18n });
// app.config.globalProperties.$openImagePreview = ImagePreview().open;
app
  .use(i18n)
  .use(I18nPlugin, {
    needLangList: ['EN', 'CN', LOCAL_LANG.value]
  })
  .use(MotionPlugin)
  .use(ElementPlus);

app.use(Avue, {
  size: '',
  tableSize: '',
  formSize: '',
  menuType: '',
  canvas: {},
  locale: avLang[i18nGlobal.locale.value]
});
getServerConfig(app).then(async config => {
  app.use(router);
  await router.isReady();
  injectResponsiveStorage(app, config);
  setupStore(app);
  app.use(useEcharts);
  // .use(Table);
  // .use(PureDescriptions);
  app.mount('#app');
});
